import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useLocation, Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

export default function ProtectedRoute({ children }) {
  const { user, loading, checkAuth } = useAuth();
  const location = useLocation();
  const [checked, setChecked] = useState(Boolean(location.state?.user) || !loading);

  useEffect(() => {
    if (location.state?.user) {
      setChecked(true);
      return;
    }
    if (!loading) {
      setChecked(true);
      return;
    }
    (async () => {
      await checkAuth();
      setChecked(true);
    })();
  }, [location.state, loading, checkAuth]);

  if (!checked || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50">
        <Loader2 className="w-8 h-8 animate-spin text-[#07301f]" />
      </div>
    );
  }

  if (!user && !location.state?.user) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
